import useGetDatabases from './useGetDatabases'

export default useGetDatabases
